import React, { useState } from 'react';

const EssentialBills = ({ onNext, answers, stepKey }) => {
  const [selectedAnswer, setSelectedAnswer] = useState(answers && answers[stepKey] ? answers[stepKey] : null);

  const handleClick = (value) => {
    setSelectedAnswer(value);
    onNext(value);
  };

  return (
    <>
      <div className="qs-card__head"><h2 className="qs-card__title">Struggled With Essential Bills?</h2></div>
      <div className="qs-card__body">
        <p className="qs-card__sub">Were you behind on any priority bills or essential payments when you applied for or held the car loan?</p>
        <div className="qs-stack">
          <button 
            type="button" 
            className={`qs-btn qs-btn--yes qs-btn--full ${selectedAnswer == 466 ? 'btn-active' : ''}`}
            onClick={() => handleClick(466)}>
            Yes
          </button>
          <button 
            type="button" 
            className={`qs-btn qs-btn--outline qs-btn--full ${selectedAnswer == 467 ? 'btn-active' : ''}`}
            onClick={() => handleClick(467)}>
            No
          </button>
          <button 
            type="button" 
            className={`qs-btn qs-btn--outline qs-btn--full ${selectedAnswer == 468 ? 'btn-active' : ''}`}
            onClick={() => handleClick(468)}>
            Not sure
          </button>
        </div>
      </div>
    </>
  );
};

export default EssentialBills;
